import { CodeSurfer, CodeSurferColumns, Step } from "code-surfer";
import { github, vsDark, shadesOfPurple, dracula } from "@code-surfer/themes";
import OverviewFlow from "..\\..\\..\\..\\slides\\src\\Overview";
import { motion } from "framer-motion";
import { Para } from "..\\..\\..\\..\\slides\\src\\Para";
import { BounceImage } from "..\\..\\..\\..\\slides\\src\\Components\\BounceImage";
import * as React from 'react';
export default {
  CodeSurfer,
  CodeSurferColumns,
  Step,
  github,
  vsDark,
  shadesOfPurple,
  dracula,
  OverviewFlow,
  motion,
  Para,
  BounceImage,
  React
};